module.exports = __webpack_public_path__ + "img/eventPosLogo.506fc8eb.png";